var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primary py-4",staticStyle:{"color":"white"}},[_c('v-container',{staticClass:"py-0 px-6",attrs:{"fluid":""}},[_vm._v("© Copyright 2019 - All Rights Reserved")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }